import { useState } from "react";
import InputGroup from "ui/forms/InputGroup";
import type { SelectProps } from "ui/forms/Select";
import Select from "ui/forms/Select";

export interface InputGroupSelectProps extends SelectProps {
  labelText: string;
  required?: boolean;
  id?: string;
}

export default function InputGroupSelect({ labelText, required, onChange, ...props }: InputGroupSelectProps) {
  const [error, setError] = useState<string>();

  return (
    <InputGroup id={props.id} labelText={labelText} errorText={error} required={required}>
      <Select
        {...props}
        onChange={(value) => {
          if (required && !value) {
            setError(`${labelText} is required`);
          }
          onChange?.(value);
        }}
      />
    </InputGroup>
  );
}
